const state = {
  status: 0,
  message: '',
  isnew: false,
  type: '',
};

const mutations = {
  push(state, { message, type = 'info'}) {
    state.message = message
    state.type = type 
    state.isnew = true
  },
  displayed(state){
    state.isnew = false;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
